import { mergeClasses } from "@fluentui/react-components";
import { useSourceDocumentTypeBadgeStyles } from "./SourceDocumentTypeBadge.styles";
import { ISourceDocumentTypeBadgeProps } from "./SourceDocumentTypeBadge.types";

export const SourceDocumentTypeBadge = ({
  documentType,
  label,
}: ISourceDocumentTypeBadgeProps): JSX.Element => {
  const styles = useSourceDocumentTypeBadgeStyles();

  const toneClassName =
    documentType === "sow"
      ? styles.toneSow
      : documentType === "proposal"
        ? styles.toneProposal
        : documentType === "change_order"
          ? styles.toneChangeOrder
          : documentType === "purchase_order"
            ? styles.tonePurchaseOrder
            : documentType === "extension"
              ? styles.toneExtension
              : styles.toneNeutral;

  return (
    <span className={mergeClasses(styles.badge, toneClassName)}>{label}</span>
  );
};
